import React from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, Typography } from '@mui/material'
import { find, map } from 'lodash'
import PropTypes from 'prop-types'

import { PUBLIC_URL } from '../../common/constants'
import {
  CrackIcon,
  DentIcon,
  Dirt2Icon,
  MultipleDamageIcon,
  RepairFailedIcon,
  Scratch2Icon,
  SingleDamageIcon,
} from '../../icons'

import DamagesList from './common/DamagesList'
import DamagesMesh from './common/DamagesMesh'

function InteriorDamages({ digitalCertificate }) {
  const { interiorConditions } = digitalCertificate
  const { t } = useTranslation()

  const damageIcons = {
    Zabrudzenie: <Dirt2Icon />,
    Rysa: <Scratch2Icon />,
    Odkształcenie: <DentIcon />,
    Pęknięcie: <CrackIcon />,
    Uszkodzenie: <SingleDamageIcon />,
    'Inne uszkodzenia': <RepairFailedIcon />,
    'Wiele uszkodzeń': <MultipleDamageIcon />,
  }

  const elementsIconsCoords = [
    { interiorElementId: 1, coords: [119, 93] },
    { interiorElementId: 2, coords: [356, 93] },
    { interiorElementId: 3, coords: [215, 53] },
    { interiorElementId: 4, coords: [215, 134] },
    { interiorElementId: 5, coords: [305, 60] },
    { interiorElementId: 6, coords: [305, 125] },
    { interiorElementId: 7, coords: [215, 9] },
    { interiorElementId: 8, coords: [215, 178] },
    { interiorElementId: 9, coords: [300, 9] },
    { interiorElementId: 10, coords: [300, 178] },
    { interiorElementId: 11, coords: [170, 53] },
    { interiorElementId: 12, coords: [170, 133] },
    { interiorElementId: 13, coords: [268, 60] },
    { interiorElementId: 14, coords: [268, 125] },
    { interiorElementId: 15, coords: [133, 133] },
    { interiorElementId: 16, coords: [450, 93] },
    { interiorElementId: 17, coords: [166, 93] },
    { interiorElementId: 18, coords: [142, 52] },
  ]
  const interiorConditionsWithCoords = map(interiorConditions, (elem) => {
    const item = find(elementsIconsCoords, {
      interiorElementId: elem.interiorElementId,
    })
    if (item) {
      const mainDamage = find(elem.interiorDamages, { isMain: true }) || false
      return {
        ...elem,
        coords: item.coords,
        mainDamage,
      }
    }
    return elem
  })

  return (
    <Grid container spacing={3}>
      <Grid item xs={5}>
        <Typography variant="h4">
          {t('interiorCondition.inspection')}
        </Typography>
        <DamagesList
          items={[
            { icon: <Dirt2Icon />, label: t('interiorDamages.dirt') },
            { icon: <Scratch2Icon />, label: t('interiorDamages.scratch') },
            { icon: <DentIcon />, label: t('interiorDamages.dent') },
            { icon: <CrackIcon />, label: t('interiorDamages.crack') },
            {
              icon: <RepairFailedIcon />,
              label: t('interiorDamages.repairFailed'),
            },
            {
              icon: <SingleDamageIcon />,
              label: t('interiorDamages.singleDamage'),
            },
            {
              icon: <MultipleDamageIcon />,
              label: t('interiorDamages.multiDamage'),
            },
          ]}
        />
      </Grid>
      <Grid item xs={7}>
        <DamagesMesh
          conditions={interiorConditionsWithCoords}
          damageIcons={damageIcons}
          mesh={`${PUBLIC_URL}/assets/images/car_interior_mesh.png`}
          prefix="interior"
          width={210}
        />
      </Grid>
    </Grid>
  )
}

InteriorDamages.propTypes = {
  digitalCertificate: PropTypes.object,
}
InteriorDamages.defaultProps = {
  digitalCertificate: {},
}

export default InteriorDamages
